'use client'

import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'

import { Card, JoinType } from '@/entities/auth'
import { Link, useRouter } from '@/shared/i18n'
import { cn, Slot } from '@/shared/lib'
import { Icon } from '@/shared/ui'

import HomeMoney from '../asset/home-money.svg'
import HomeSearch from '../asset/home-search.svg'

export const SignUpPage = () => {
  const router = useRouter()

  const locale = useLocale()
  const t = useTranslations('signup_user_role')

  const options = [
    {
      joinType: JoinType.GUEST,
      title: t('tenant_title'),
      description: t('tenant_description'),
      image: <HomeSearch className="mx-auto block" />,
      href: `/sign-up/guest?step=intro`,
    },
    {
      joinType: JoinType.HOST,
      title: t('landlord_title'),
      description: t('landlord_description'),
      image: <HomeMoney className="mx-auto block" />,
      href: '/sign-up/host?step=intro',
    },
  ] as const

  const [selected, setSelected] = useState<JoinType>()

  return (
    <Card className="text-center">
      <Slot name="title">{t('title')}</Slot>
      <Slot name="children">
        <div className="mt-15 flex gap-4">
          {options.map(({ joinType, title, description, image, href }) => (
            <Link
              key={joinType}
              className={cn(
                'group relative h-[197px] flex-1 cursor-pointer rounded-xl border border-transparent bg-gray-50 p-6 text-center transition-all',
                'hover:bg-purple-50',
                'active:border-black active:bg-purple-50',
                selected === joinType && 'border-black bg-purple-50',
                locale === 'en' && 'px-4',
              )}
              href={href}
              onClick={e => {
                e.preventDefault()
                setSelected(joinType)
                setTimeout(() => {
                  router.push(href)
                }, 200)
              }}
            >
              <div
                className={cn(
                  'absolute top-3 right-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 transition-all',
                  'group-active:bg-black',
                  selected === joinType && 'bg-black',
                )}
              >
                <Icon name="check" size={16} className="text-white" />
              </div>
              {image}
              <h3 className="typo-headline2 mt-4 font-bold whitespace-break-spaces text-black">
                {title}
              </h3>
              <span
                className={cn(
                  'typo-label1 mt-1.5 block text-gray-600 transition-all',
                  'group-active:text-black',
                  selected === joinType && 'text-black',
                )}
              >
                {description}
              </span>
            </Link>
          ))}
        </div>
      </Slot>
    </Card>
  )
}
